import { render, staticRenderFns } from "./RunnerFlucs.vue?vue&type=template&id=5bf60806&scoped=true&"
import script from "./RunnerFlucs.vue?vue&type=script&lang=js&"
export * from "./RunnerFlucs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf60806",
  null
  
)

export default component.exports